import axios from 'axios'

export default {
  namespaced: true,
  state: {
    userInfo: {
      name: '',
      userCode: '',
      email: '',
      password: '',
    }
  },
  getters: {
    RegisterInfo:(state)=>state.userInfo
  },
  mutations: {
    confirm (state, data) {
      state.userInfo.name = data.name
      state.userInfo.userCode = data.user_code
      state.userInfo.email = data.email
      state.userInfo.password = data.password
    },
    create (state) {
      state.userInfo = {}
    },
  },
  actions: {
    async confirm({ commit }, data) {
      await commit('confirm', data.user)
    },
    async create({ commit }, data) {
      data.user_code = data.userCode
      await axios.post(process.env.VUE_APP_API_BASE_URL + '/user', data)
      commit('create')
    },
  }
}